import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider, db } from './firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

export const signInWithGoogle = async () => {
    try {
        const result = await signInWithPopup(auth, googleProvider);
        const user = result.user;
        return user;
    } catch (error) {
        console.error("Error signing in with Google", error);
        throw error;
    }
};

export const getUserHighScore = async (uid) => {
    if (!uid) return 0;

    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);
    if (!snap.exists()) return 0;

    const data = snap.data();
    return typeof data.topScore === "number" ? data.topScore : 0;
};

export const setUserHighScore = async (uid, topScore) => {
    if (!uid) return;

    const ref = doc(db, "users", uid);
    await setDoc(
        ref,
        {
            topScore,
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
};

export const getUserCollection = async (uid) => {
    if (!uid) return [];

    const ref = doc(db, "users", uid);
    const snap = await getDoc(ref);
    if (!snap.exists()) return [];

    const data = snap.data();
    const arr = Array.isArray(data.collectionUnlocked) ? data.collectionUnlocked : [];
    // Normalize to numbers when possible
    return arr
        .map((x) => {
            const n = Number(x);
            return Number.isFinite(n) ? n : x;
        })
        .filter((x) => x !== null && x !== undefined);
};

export const setUserCollection = async (uid, collectionUnlocked) => {
    if (!uid) return;

    const ref = doc(db, "users", uid);
    await setDoc(
        ref,
        {
            collectionUnlocked: Array.isArray(collectionUnlocked)
                ? collectionUnlocked
                : [],
            updatedAt: serverTimestamp(),
        },
        { merge: true }
    );
};
